/**
 * FeedbackButton Component
 * 
 * A floating action button that triggers the feedback modal
 */

import { FeedbackModal } from './FeedbackModal.js'

export class FeedbackButton {
  constructor(options = {}) {
    this.options = {
      position: 'bottom-right', // bottom-right, bottom-left, top-right, top-left
      offset: { bottom: '20px', right: '20px' },
      onFeedbackSubmitted: options.onFeedbackSubmitted || (() => { }),
      onEmailSubmitted: options.onEmailSubmitted || (() => { }),
      ...options
    }

    this.button = null
    this.feedbackModal = null
    this.isVisible = true

    this.createButton()
    this.createFeedbackModal()
    this.setupEventListeners()
  }

  createButton() {
    this.button = document.createElement('button')
    this.button.className = 'feedback-button'
    this.button.setAttribute('aria-label', 'Give feedback')
    this.button.setAttribute('title', 'Help us improve! Share your feedback')

    this.button.innerHTML = `
            <span class="feedback-button-icon">💬</span>
        `

    // Position the button
    this.button.style.position = 'fixed'
    this.button.style.bottom = this.options.offset.bottom
    this.button.style.right = this.options.offset.right
    this.button.style.zIndex = '1000'

    document.body.appendChild(this.button)
  }

  createFeedbackModal() {
    this.feedbackModal = new FeedbackModal({
      onFeedbackSubmitted: (data) => {
        console.log('✅ Feedback submitted:', data)
        this.options.onFeedbackSubmitted(data)
      },
      onEmailSubmitted: (data) => {
        console.log('📧 Email submitted:', data)
        this.options.onEmailSubmitted(data)
      },
      onClose: () => {
        // Optional: Track when users close without submitting
        console.log('❌ Feedback modal closed')
      }
    })
  }

  setupEventListeners() {
    this.button.addEventListener('click', () => {
      this.showFeedbackModal()
    })

    // Add hover effects
    this.button.addEventListener('mouseenter', () => {
      this.button.classList.add('feedback-button-hover')
    })

    this.button.addEventListener('mouseleave', () => {
      this.button.classList.remove('feedback-button-hover')
    })

    // Keyboard accessibility
    this.button.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault()
        this.showFeedbackModal()
      }
    })
  }

  showFeedbackModal() {
    if (this.feedbackModal) {
      this.feedbackModal.show()
    }
  }

  show() {
    if (this.button) {
      this.button.style.display = 'flex'
      this.isVisible = true
    }
  }

  hide() {
    if (this.button) {
      this.button.style.display = 'none'
      this.isVisible = false
    }
  }

  toggle() {
    if (this.isVisible) {
      this.hide()
    } else {
      this.show()
    }
  }

  destroy() {
    if (this.button && this.button.parentNode) {
      this.button.parentNode.removeChild(this.button)
    }

    if (this.feedbackModal) {
      this.feedbackModal.destroy()
    }
  }
}
